(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("2n1zy", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1b9ef3084b65f702$export$6503ec6e8aabbaf; }, function (v) { return $1b9ef3084b65f702$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1b9ef3084b65f702$export$f7ad0328861e2f03; }, function (v) { return $1b9ef3084b65f702$export$f7ad0328861e2f03 = v; });
var $1b9ef3084b65f702$export$6503ec6e8aabbaf;
var $1b9ef3084b65f702$export$f7ad0328861e2f03;
"use strict";
var $1b9ef3084b65f702$var$mapping = {};
function $1b9ef3084b65f702$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$1b9ef3084b65f702$var$mapping[keys[i]] = pairs[keys[i]];
}
function $1b9ef3084b65f702$var$resolve(id) {
    var resolved = $1b9ef3084b65f702$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$1b9ef3084b65f702$export$6503ec6e8aabbaf = $1b9ef3084b65f702$var$register;
$1b9ef3084b65f702$export$f7ad0328861e2f03 = $1b9ef3084b65f702$var$resolve;

});

var $9f63e19225e2fa66$exports = {};

(parcelRequire("2n1zy")).register(JSON.parse('{"15lvv":"index.f9961ad8.js","7fb3i":"apple-touch-icon.176c0538.png","4wBTJ":"favicon.561cee98.png","4YVoE":"index.767b9897.css"}'));

})();
//# sourceMappingURL=index.8da97eb5.js.map
